var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn",attrs:{"to":_vm.to}},[_vm._t("default"),_vm._v(" "),(_vm.icon)?_c('icon',{attrs:{"icon":_vm.icon}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }